import React from "react";
import SEO from "../SEO/SEO";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <>
      {/* SEO Optimization */}
      <SEO
        title="Contact RS Transports - 24/7 Premium Airport Transfers"
        description="Get in touch with RS Transports for reliable 24/7 airport transfer services in Paris. Book your ride with our professional drivers and travel in comfort."
        keywords="contact RS Transports, book transfer, airport pickup, private chauffeur, premium transport"
      />

      {/* Page Header */}
      
      <section id="legal-notice" className="py-5">
        <div className="container-fluid py-5 text-center text-warning bg-dark">
          <div className="row">
            <h1 className="text-center mb-4">Contact Us</h1>
            <h2>24/7 Airport Transfer Service</h2>
            <h3>Email: <a href="mailto:contact@rstransports.com" className="text-warning">contact@rstransports.com</a></h3>
            <h3>Phone: <a href="tel:+33668160842" className="text-warning">00 33 6 68 16 08 42</a></h3>
            <p>Need a trusted chauffeur? Contact us today to arrange your premium airport transfer.</p>
          </div>
        </div>

      {/* Contact Form */}
      
      <div className="container py-5 text-center text-warning bg-jaune">
        <ContactForm />
      </div>
     </section>
    </>
  );
};

export default Contact;
